
























import Vue from 'vue';
import FormField from './FormField.vue';
import MultiContainRelation from './MultiContainRelation.vue';
import SelectRemarkBox from '../../remarks/SelectRemarkBox.vue';
import customerVuex from '../../../vuex/common';
import CustomerRemark from '../../../models/CustomerRemark';
import { RemarkGroup } from '@/customer/models/RemarkGroup';
import { RemarkFilter } from '../../../models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
    MultiContainRelation,
    SelectRemarkBox,
  },
  data() {
    return {
      showRemarkBox: false,
    };
  },
  computed: {
    remarkAndGroupCount(): boolean {
      const remarkCond = this.customerState.customerFilter && this.customerState.customerFilter.remark;
      const remarks = remarkCond && remarkCond.remarks;
      const groups = remarkCond && remarkCond.remarkGroups;

      return (remarks && remarks.length) + (groups && groups.length);

    },
  },
  methods: {
    confirmRemarkBox(selectedRemarks: CustomerRemark[], selectedGroups: RemarkGroup[]) {
      const v = this.customerState.customerFilter.remark;
      v.remarks = selectedRemarks;
      v.remarkGroups = selectedGroups;
      this.updateRemarkFilter(v);
      this.showRemarkBox = false;
    },
    updateRelation(notIn: boolean, or: boolean) {
      const v = this.customerState.customerFilter.remark;
      v.notIn = notIn;
      v.or = or;
      this.updateRemarkFilter(v);
    },
    updateRemarkFilter(filter: RemarkFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'remark',
        value: filter,
      });
    },
  },
});
